export const initialState = {
    name: '',
};

export const carriersPath = '/carriers';

export const breadCrumbTrail = [
    { label: 'Admin', path: '' },
    { label: 'Carriers', path: carriersPath },
    { label: 'Add Carrier', path: '' },
];

export const breadCrumbTrailEdit = [
    { label: 'Admin', path: '' },
    { label: 'Carriers', path: carriersPath },
    { label: 'Edit Carrier', path: '' },
];

export const addHeader = 'Carrier Details';
export const editHeader = 'Edit Carrier Details';

export const ERROR_MESSAGES = {
    NAME_REQUIRED: 'Carrier name is required',
};

export const carrierStatuses = {
    0: { type: 'active', displayedName: 'OK' },
    default: { type: 'disabled', displayedName: 'Unknown' },
};

export const getCarrierStatus = (value) =>
    carrierStatuses[value] ? value : 'default';
